<template>
  <router-view/>
</template>

<script>
export default {
  name: "AdminTaxonomies"
}
</script>
